
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"36","height":"36","viewBox":"0 0 250 156.12"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"d":"M162.184 81.401c-3.403 13.011-11.344 15.877-15.581 16.452-2.61 5.218-8.347 15.882-14.086 21.24-2.294 2.141-5.275 3.948-8.86 5.371-4.577 1.816-9.411 2.737-14.366 2.737s-9.789-.921-14.366-2.737c-3.584-1.422-6.566-3.229-8.86-5.371-5.74-5.357-11.477-16.022-14.087-21.24-4.236-.575-12.177-3.44-15.58-16.452-1.82-6.958-1.354-12.63 1.386-16.859a13.16 13.16 0 014.046-4.004c.004-1.389.062-3.128.223-5.106-2.461-3.42-5.807-10.799-1.663-22.743 4.38-12.627 14.283-14.577 19.063-14.746 1.616-3.004 4.669-7.269 10.213-11.19C95.82 2.398 103.856 0 112.293 0c10.382 0 20.829 3.654 30.211 10.567 15.211 11.208 13.908 36.07 13.535 40.584.552 3.784.705 7.066.712 9.386a13.16 13.16 0 014.046 4.004c2.74 4.23 3.206 9.901 1.387 16.86zm44.486 96.889v35.291a5 5 0 01-5 5H16.911a5 5 0 01-5-5V178.29c0-14.458 8.674-27.27 22.098-32.64l43.715-17.486a4.999 4.999 0 016.558 2.942l10.99 30.383 2.176-6.256-3.462-8.463a5.001 5.001 0 014.628-6.893h21.354a5 5 0 014.628 6.893l-3.462 8.463 2.176 6.256 10.99-30.383a4.996 4.996 0 012.655-2.861 5.008 5.008 0 013.903-.081l43.715 17.486c13.424 5.37 22.097 18.182 22.097 32.64zm-26.616 3.837a5 5 0 00-5-5h-33.57a5 5 0 00-5 5v15.59a5 5 0 005 5h33.57a5 5 0 005-5v-15.59z"}})])
          )
        }
      }
    